import { ThemeMO } from '../models/ThemeMO';
import { ExclusionsMO } from '../models/ExclusionsMO';

export class LocalStorageManager {
	private static _themeName = 'wd-Theme';
	private static _exclusionsName = 'wd-Exclusions';

	static tryCatchWrapper = (functionCaller: Function): any => {
		try {
			return functionCaller() as any;
		} catch {
			return null;
		}
	};
	static getThemeMOFromLocalStorage = () => {
		return LocalStorageManager.tryCatchWrapper(() => {
			let _themeMO: ThemeMO = JSON.parse(
				localStorage.getItem(LocalStorageManager._themeName),
			);
			return _themeMO;
		});
	};

	static setThemeMOToLocalStorage = (themeMO: ThemeMO) => {
		LocalStorageManager.tryCatchWrapper(() => {
			let lsThemeMO = JSON.stringify(themeMO);
			localStorage.setItem(LocalStorageManager._themeName, lsThemeMO);
		});
	};

	static getExclusionsMOFromLocalStorage = () => {
		return LocalStorageManager.tryCatchWrapper(() => {
			let _exclusionsMO: ExclusionsMO = JSON.parse(
				localStorage.getItem(LocalStorageManager._exclusionsName),
			);
			return _exclusionsMO;
		});
	};

	static setExclusionsMOToLocalStorage = (exclusionsMO: ExclusionsMO) => {
		LocalStorageManager.tryCatchWrapper(() => {
			let lsExclusionMO = JSON.stringify(exclusionsMO);
			localStorage.setItem(LocalStorageManager._exclusionsName, lsExclusionMO);
		});
	};
}
